// Mock data for CompareYourOptions.com.au website

export const OLLIE_IMAGES = {
  waving: 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/8k249cvj_Asset%202.png',
  armsCrossed: 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/vyxkqeyj_Asset%203.png',
  holdingSign: 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/nxy2xqvq_Asset%204.png',
  reading: 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/hyujk2te_Asset%205.png',
  withTie: 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/m987xk08_Asset%206.png',
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aussiecompare/artifacts/x8grkxw7_logo-cyo.png';

export const HERO_IMAGE = 'https://images.pexels.com/photos/9875680/pexels-photo-9875680.jpeg?auto=compress&cs=tinysrgb&w=1200';

export const PRODUCT_CATEGORIES = [
  {
    id: 'solar',
    name: 'Solar Systems',
    description: 'Reduce your electricity bills with solar power',
    icon: 'Sun',
    benefit: 'Save up to 70% on electricity bills',
  },
  {
    id: 'battery',
    name: 'Battery Storage',
    description: 'Store excess solar energy for later use',
    icon: 'Battery',
    benefit: 'Power your home day and night',
  },
  {
    id: 'ev-charger',
    name: 'EV Chargers',
    description: 'Charge your electric vehicle at home',
    icon: 'Car',
    benefit: 'Convenient home charging solutions',
  },
  {
    id: 'heat-pump',
    name: 'Heat Pumps',
    description: 'Energy-efficient hot water systems',
    icon: 'Thermometer',
    benefit: 'Up to 3x more efficient than traditional systems',
  },
  {
    id: 'hvac',
    name: 'Heating & Cooling',
    description: 'Efficient climate control for your home',
    icon: 'Wind',
    benefit: 'Year-round comfort and energy savings',
  },
];

export const HOW_IT_WORKS_STEPS = [
  {
    step: 1,
    title: 'Choose what you want to compare',
    description: 'Select from solar, batteries, EV chargers or heat pumps',
    icon: 'Search',
  },
  {
    step: 2,
    title: 'See tailored options',
    description: 'Get personalised quotes based on your needs and location',
    icon: 'ListChecks',
  },
  {
    step: 3,
    title: 'Connect & save',
    description: 'Connect with trusted providers and start saving',
    icon: 'Handshake',
  },
];

export const WHY_COMPARE_REASONS = [
  {
    title: 'Independent & Transparent',
    description: 'We provide unbiased comparisons with no hidden agendas',
    icon: 'Shield',
  },
  {
    title: 'Free to Use',
    description: 'Our comparison service is completely free with no obligations',
    icon: 'BadgeDollarSign',
  },
  {
    title: 'Clear Comparisons',
    description: 'Easy-to-understand side-by-side comparisons',
    icon: 'BarChart3',
  },
  {
    title: 'Save Time & Money',
    description: 'Find the best deals without the legwork',
    icon: 'Clock',
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Solar Customer',
    location: 'NSW',
    rating: 5,
    text: 'The comparison tool made it easy to understand my solar options and find the right system for my home.',
    product: 'Solar Systems',
  },
  {
    id: 2,
    name: 'EV Owner',
    location: 'VIC',
    rating: 5,
    text: 'Quick and straightforward comparison process. Helped me choose the right EV charger without the hassle.',
    product: 'EV Chargers',
  },
  {
    id: 3,
    name: 'Battery User',
    location: 'QLD',
    rating: 5,
    text: 'The site explained battery storage clearly and helped me compare different options side by side.',
    product: 'Battery Storage',
  },
];

export const INSIGHTS = [
  {
    id: 1,
    title: 'Solar Basics: What You Need to Know',
    excerpt: 'Everything you need to know about solar panels for your home.',
    category: 'Solar',
    readTime: '5 min read',
  },
  {
    id: 2,
    title: 'Battery Storage: Is It Worth It?',
    excerpt: 'Understanding the benefits and costs of home battery systems.',
    category: 'Battery',
    readTime: '4 min read',
  },
  {
    id: 3,
    title: 'EV Charging Explained',
    excerpt: 'A guide to home EV charging options and what to consider.',
    category: 'EV Chargers',
    readTime: '6 min read',
  },
];

export const NAV_LINKS = [
  { name: 'Compare & Save', href: '#compare' },
  { name: 'Products', href: '#products' },
  { name: 'How It Works', href: '#how-it-works' },
  { name: 'Insights', href: '#insights' },
  { name: 'About', href: '#about' },
];

export const AUSTRALIAN_STATES = [
  'NSW',
  'VIC',
  'QLD',
  'WA',
  'SA',
  'TAS',
  'NT',
  'ACT',
];
